var map = {
	"./_base-breadcrumbs.vue": 898,
	"./_base-button-genre.vue": 1699,
	"./_base-button-play.vue": 732,
	"./_base-button.vue": 2986,
	"./_base-card-link.vue": 8607,
	"./_base-card.vue": 1687,
	"./_base-content.vue": 2657,
	"./_base-custom-select.vue": 956,
	"./_base-dots.vue": 2631,
	"./_base-dropdown.vue": 9356,
	"./_base-empty-list.vue": 2697,
	"./_base-favourites.vue": 822,
	"./_base-hero-background.vue": 5087,
	"./_base-hero.vue": 1356,
	"./_base-icon.vue": 6711,
	"./_base-input.vue": 2859,
	"./_base-link.vue": 8465,
	"./_base-load-more.vue": 3903,
	"./_base-placeholder.vue": 2374,
	"./_base-resource-cover.vue": 5055,
	"./_base-resource-image.vue": 7463,
	"./_base-search-input.vue": 8548,
	"./_base-section.vue": 4808,
	"./_base-select.vue": 5830,
	"./_base-spinner.vue": 9216,
	"./_base-tab-list.vue": 6983,
	"./_base-tab-panel.vue": 2914,
	"./_base-tab.vue": 2311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8957;